<template>
  <div class="btn_list" v-if="btnList.length">
    <van-swipe class="swiper_btn"
               :loop="false"
               :show-indicators="false"
               @change="changeSwiper"
    >
      <van-swipe-item class="swiper_item"
                      v-for="(list, index) in btnList"
                      :key="index"
      >
        <div class="item" v-for="(image, index) in list" :key="index" @click="toDetail(image)">
          <img :src="image.imgUrl" class="icon" alt="" />
          <div class="text">{{ image.label || ' - ' }}</div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="add_f" v-if="btnList.length > 1">
      <text
          class="dot"
          v-for="(items, index) in btnList"
          :key="index"
          :class="activeBtnTab === index ? 'active' : ''"
      ></text>
    </div>
  </div>
</template>

<script>
import { pathMatch } from '../../common'

export default {
  name: 'icon-btn-list',
  components: {},
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      activeBtnTab: '',
      btnList: []
    }
  },
  created() {
  },
  mounted() {
    this.getData()
  },
  methods: {
    changeSwiper (index) {
      this.activeBtnTab = index
    },
    toDetail ({ path = '', params = '' }) {
      const _path = (pathMatch[path] || '') + params
      _path && this.$router.push(_path)
    },
    getData () {
      const { list = [] } = this.config.moduleData
      this.btnList = this.getSubArray(list, 4)
    },
    getSubArray (arr, num) {
      let len = arr.length
      let n = num || 4
      let lineNum = len % n === 0 ? len / num : Math.floor(len / num + 1)
      let res = []
      for (let i = 0; i < lineNum; i++) {
        let temp = arr.slice(i * n, i * n + n)
        res.push(temp)
      }
      return res
    }
  }
}
</script>

<style scoped lang="stylus">
.btn_list {
  padding-top:16px;
  padding-bottom:26px
  background: #ececec
  /deep/ .van-swipe__track {
    overflow: hidden
  }
  .swiper_btn {
    height: 65px;
  }

  .swiper_item {
    .item {
      width: 25%;
      display: inline-block;
      text-align: center;

      .icon {
        width: 40px;
        height: 40px;
      }

      .text {
        font-size: 14px;
        line-height: 20px;
        color: #333333;
      }
    }
  }
}
</style>
